import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import logo from "../../assets/logo.png";
import { PATH } from "../../routes/Routes";
import { useTranslation } from "react-i18next";
import { Media } from "../../AppMedia";
import useLanguage from "../../hooks/useLanguage";
import { useUserContext } from "../../hooks/UserSettingProvider";
import {
  SettingOutlined,
  GlobalOutlined,
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Space, Row, Col, Dropdown, Menu, Layout } from "antd";
import ConfirmModalLogout from "./ConfirmModalLogout";

export const MENU_APPROVE_LOGWOOD = "approve_log_wood";
export const MENU_WOOD_IMPORT = "wood_import";
export const MENU_WOOD_IMPORT_SETTINGS_PRICE = "wood_import_settings_price";
export const MENU_FACTORY_WOOD_EXPORT = "factory_wood_export";
export const MENU_BOM = "bom";
export const MENU_WOOD_EXPORT = "wood_export";
export const MENU_REPORT = "report";
export const MENU_INTERFACE_AX = "interface_AX";
export const MENU_ADMIN = "admin";

function MainHeader(props) {
  const { activeItem, hide } = props;

  const history = useHistory();

  const { t } = useTranslation();

  const { user } = useUserContext();
  const { language, setLanguage } = useLanguage();
  const [confirmLogoutVisible, setConfirmLogoutVisible] = useState(false);

  const headerStyle = {
    position: "fixed",
    top: 0,
    zIndex: 1000,
  };
  const menuStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    padding: "0 26px",
  };

  const iconStyle = { fontSize: "20px" };

  const linkStyle = (isActive, isFullHeight) => ({
    color: isActive ? "white" : "inherit",
    userSelect: "none",
    cursor: "pointer",

    ...(isFullHeight && {
      height: "100%",
      display: "flex",
      width: "100%",
    }),
  });

  const renderDropdownLink = (
    Item1,
    Item2,
    onClick,
    isActive,
    isFullHeight = false
  ) => (
    <span
      style={linkStyle(isActive, isFullHeight)}
      onClick={onClick}
      onMouseEnter={(e) =>
        Object.assign(e.currentTarget.style, linkStyle(true, isFullHeight))
      }
      onMouseLeave={(e) =>
        Object.assign(e.currentTarget.style, linkStyle(isActive, isFullHeight))
      }
    >
      <Space>
        <span>
          <strong>
            {Item1} {Item2}
          </strong>
        </span>
      </Space>
    </span>
  );

  const dropdownRender = (menu) => {
    return <div> {menu} </div>;
  };

  const handleLogout = () => {
    setConfirmLogoutVisible(true);
  };

  const cancelLogout = () => {
    setConfirmLogoutVisible(false);
  };

  const [isActive, setisActive] = React.useState(false);

  const logoLayout = () => {
    return (
      <div
        onClick={() => history.push(PATH.HOME)}
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <img src={logo} alt="logo" style={{ width: 40, marginRight: 12 }} />
        <span
          style={{ fontSize: 18, ...linkStyle(isActive) }}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, linkStyle(true))
          }
          onMouseLeave={(e) =>
            Object.assign(e.currentTarget.style, linkStyle(isActive))
          }
        >
          <strong>WoodWork</strong>
        </span>
      </div>
    );
  };

  const accountMenu = (
    <Menu>
      <div style={{ margin: "9px", fontWeight: "bold" }}>
        {user.display_name}
      </div>
      <Menu.Divider />
      <Menu.Item
        key="userProfile"
        onClick={() => history.push(PATH.USER_PROFILE)}
      >
        <Space>
          <UserOutlined style={iconStyle} />
          {t("menus.user_profile")}
        </Space>
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        <Space>
          <LogoutOutlined style={iconStyle} />
          {t("menus.log_out")}
        </Space>
      </Menu.Item>
    </Menu>
  );

  const desktopLayout = () => {
    const items = [
      { key: "th", label: "TH" },
      { key: "en", label: "EN" },
    ];
    const rightLayout = () => (
      <div>
        <Row gutter={24}>
          <Col>
            {user.groups &&
              user.groups.length > 0 &&
              user.groups.includes("admin") &&
              renderDropdownLink(
                <SettingOutlined style={iconStyle} />,
                t("menus.admin"),
                () => history.push(PATH.ADMIN),
                activeItem === "admin",
                true
              )}
          </Col>
          <Col>
            <Dropdown menu={{ items, onClick: ({ key }) => setLanguage(key) }}>
              {renderDropdownLink(
                <GlobalOutlined style={iconStyle} />,
                ` ${language?.toUpperCase()}`
              )}
            </Dropdown>
          </Col>
          <Col>
            <Dropdown overlay={accountMenu}>
              {renderDropdownLink(<UserOutlined style={iconStyle} />)}
            </Dropdown>
          </Col>
        </Row>
      </div>
    );

    const handleMenuClick = (path) => {
      history.push(path);
    };
    const woodMenu = (
      <Menu onClick={({ key }) => handleMenuClick(key)}>
        <Menu.Item key={PATH.LOG_WOOD_PO}>
          {t("menus.wood_menus.log_wood_po")}
        </Menu.Item>
        <Menu.Item key={PATH.WOOD_IMPORT}>
          {t("menus.wood_menus.wood_import")}
        </Menu.Item>
        <Menu.Item key={PATH.WOOD_IMPORT_SETTINGS_PRICE}>
          {t("menus.wood_menus.wood_import_settings_price")}
        </Menu.Item>
        {user.groups?.includes("officer") && (
          <Menu.Item key={PATH.FACTORY_WOOD_EXPORT}>
            {t("menus.wood_menus.factory_wood_export")}
          </Menu.Item>
        )}
        <Menu.Item key={PATH.BOM}>{t("menus.wood_menus.bom")}</Menu.Item>
        {user.groups?.includes("export") && (
          <Menu.Item key={PATH.EXPORT_TRANSACTION}>
            {t("menus.wood_menus.export_transaction")}
          </Menu.Item>
        )}
      </Menu>
    );

    const interfaceMenu = (
      <Menu onClick={({ key }) => handleMenuClick(key)}>
        <Menu.Item key={PATH.INTERFACE_AX_LOG_WOOD_PO}>
          {t("menus.interface_ax_menus.log_wood_po")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_PROCESSED_WOOD_PO}>
          {t("menus.interface_ax_menus.processed_wood_po")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_MOVEMENT_ISSUE}>
          {t("menus.interface_ax_menus.movement_issue")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_MOVEMENT_RECEIPT}>
          {t("menus.interface_ax_menus.movement_receipt")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_BOM_TRANSACTION}>
          {t("menus.interface_ax_menus.bom")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_EXPORT_TRANSACTION}>
          {t("menus.interface_ax_menus.export_transaction")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_POST_BAKING_WASTE_WOOD_COUNT}>
          {t("menus.interface_ax_menus.post_baking_waste_wood_count")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_WASTE_WOOD_ORDER_GRADING}>
          {t("menus.interface_ax_menus.waste_wood_order_grading")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_WASTE_WOOD_ORDER}>
          {t("menus.interface_ax_menus.waste_wood_order")}
        </Menu.Item>
        <Menu.Item key={PATH.INTERFACE_AX_BOM_WASTE_WOOD}>
          {t("menus.interface_ax_menus.bom_waste_wood")}
        </Menu.Item>
      </Menu>
    );

    const reportMenu = (
      <Menu onClick={({ key }) => handleMenuClick(key)}>
        <Menu.SubMenu title={t("menus.report_menus.log_wood")}>
          <Menu.Item key={PATH.REPORT_LOG_WOOD_LENGTH}>
            {t("menus.report_menus.log_wood_menus.log_wood_length")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_LOG_WOOD_LENGTH_COMPANY}>
            {t("menus.report_menus.log_wood_menus.log_wood_length_by_customer")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_LOG_WOOD_SPECIES}>
            {t("menus.report_menus.log_wood_menus.log_wood_species")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_LOG_WOOD_SPECIES_COMPANY}>
            {t("menus.report_menus.log_wood_menus.log_wood_species_by_customer")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_LOG_WOOD_CUT_WEIGHT}>
            {t("menus.report_menus.log_wood_menus.cut_weight")}
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu title={t("menus.report_menus.wood_import")}>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT}>
            {t("menus.report_menus.wood_import_menus.wood_import_detail")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_COMPANY}>
            {t("menus.report_menus.wood_import_menus.wood_import_by_customer")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_COMPANY_DATE}>
            {t("menus.report_menus.wood_import_menus.wood_import_by_customer_and_date")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_THICK}>
            {t("menus.report_menus.wood_import_menus.wood_import_by_width")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_VOLUME}>
            {t("menus.report_menus.wood_import_menus.wood_import_by_volume")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_WOOD_CODE}>
            {t("menus.report_menus.wood_import_menus.wood_import_by_wood_code")}
          </Menu.Item>
          <Menu.Item key={PATH.REPORT_WOOD_IMPORT_OUT_GRADE}>
            {t("menus.report_menus.wood_import_menus.wood_import_out_grade")}
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu title={t("menus.report_menus.waste_wood")}>
          <Menu.Item key={PATH.POST_BAKING_WASTE_WOOD_COUNT_REPORT}>
            {t("menus.report_menus.waste_woods.post_baking_waste_wood_count")}
          </Menu.Item>
          <Menu.Item key={PATH.POST_BAKING_WASTE_WOOD_INPUT_REPORT}>
            {t("menus.report_menus.waste_woods.post_baking_waste_wood_input")}
          </Menu.Item>
          <Menu.Item key={PATH.POST_BAKING_WASTE_WOOD_SUMMARY_REPORT}>
            {t("menus.report_menus.waste_woods.post_baking_waste_wood_summary")}
          </Menu.Item>
          <Menu.Item key={PATH.POST_BAKING_WASTE_WOOD_INPUT_SUMMARY_REPORT}>
            {t("menus.report_menus.waste_woods.post_baking_waste_wood_input_summary")}
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    );

    return (
      <Layout.Header style={headerStyle}>
        <Row>
          <Menu
            mode="horizontal"
            theme="dark"
            style={{
              ...menuStyle,
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Col flex="auto">
              <Space
                size="large"
                style={{ display: "flex", alignItems: "center" }}
              >
                {logoLayout()}
                {hide !== false && (
                  <Dropdown overlay={woodMenu} dropdownRender={dropdownRender}>
                    {renderDropdownLink(
                      t("menus.wood_menu"),
                      <DownOutlined />,
                      (e) => e.preventDefault(),
                      false,
                      true
                    )}
                  </Dropdown>
                )}
                {hide !== false && (
                  <Dropdown
                    overlay={interfaceMenu}
                    dropdownRender={dropdownRender}
                  >
                    {renderDropdownLink(
                      t("menus.interface_ax"),
                      <DownOutlined />,
                      (e) => e.preventDefault(),
                      false,
                      true
                    )}
                  </Dropdown>
                )}
                {hide !== false && (
                  <Dropdown
                    overlay={reportMenu}
                    dropdownRender={dropdownRender}
                  >
                    {renderDropdownLink(
                      t("menus.report"),
                      <DownOutlined />,
                      (e) => e.preventDefault(),
                      false,
                      true
                    )}
                  </Dropdown>
                )}
              </Space>
            </Col>
            <Col>{rightLayout()}</Col>
          </Menu>
        </Row>
      </Layout.Header>
    );
  };

  const mobileLayout = () => {
    const mobileMenu = (
      <Menu style={{ width: 230, textAlign: "left" }}>
        <Menu.Item
          key="logWoodPO"
          onClick={() => history.push(PATH.LOG_WOOD_PO)}
        >
          {t("menus.wood_menus.log_wood_po")}
        </Menu.Item>
        <Menu.Item
          key="woodImport"
          onClick={() => history.push(PATH.WOOD_IMPORT)}
        >
          {t("menus.wood_menus.wood_import")}
        </Menu.Item>
        <Menu.Item
          key="postBakingWasteWoodCount"
          onClick={() => history.push(PATH.POST_BAKING_WASTE_WOOD_COUNT)}
        >
          {t("menus.wood_menus.post_baking_waste_wood_count")}
        </Menu.Item>
        <Menu.Item
          key="postBakingWasteWoodInput"
          onClick={() => history.push(PATH.POST_BAKING_WASTE_WOOD_INPUT)}
        >
          {t("menus.wood_menus.post_baking_waste_wood_input")}
        </Menu.Item>
      </Menu>
    );

    return (
      <Layout.Header style={headerStyle}>
        <Menu theme="dark" style={menuStyle}>
          <Row style={{ justifyContent: "space-between" }}>
            <Col>
              <Space size={"large"}>
                {hide !== false && (
                  <Dropdown
                    overlay={mobileMenu}
                    trigger={["click"]}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    dropdownRender={dropdownRender}
                  >
                    {renderDropdownLink(
                      <MenuOutlined style={iconStyle} />,
                      null,
                      () => {},
                      false,
                      true
                    )}
                  </Dropdown>
                )}

                {logoLayout()}
              </Space>
            </Col>
            <Col span={3}>
              <Dropdown overlay={accountMenu} trigger={["click"]}>
                {renderDropdownLink(<UserOutlined style={iconStyle} />)}
              </Dropdown>
            </Col>
          </Row>
        </Menu>
      </Layout.Header>
    );
  };

  return (
    <>
      <Media at={"sm"}>{mobileLayout()}</Media>
      <Media greaterThan={"sm"}>{desktopLayout()}</Media>
      <ConfirmModalLogout open={confirmLogoutVisible} onClose={cancelLogout} />
    </>
  );
}

export default MainHeader;

MainHeader.propTypes = {
  activeItem: PropTypes.string,
  hide: PropTypes.bool,
};

MainHeader.defaultProps = {
  activeItem: MENU_APPROVE_LOGWOOD,
  hide: true,
};
